import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { DefaultModuleService } from 'app/shared/services/data-services/navigation/default-module.service';
import Keycloak from 'keycloak-js';

const isAccessAllowed = async (route: ActivatedRouteSnapshot, _: RouterStateSnapshot, authData: AuthGuardData): Promise<boolean | UrlTree> => {
  const { authenticated } = authData;
  const router = inject(Router);
  const defaultModuleService = inject(DefaultModuleService);
  const keycloak = inject(Keycloak);

  const module = route.routeConfig.data?.role;

  if (!authenticated) {
    authData.keycloak.login();
    return;
  }

  if (!keycloak.hasRealmRole('app_windlog')) {
    authData.keycloak.logout();
    return;
  }

  if (!keycloak.hasRealmRole(module)) {
    router.navigate([defaultModuleService.getDefaultModule()]);
  }

  return keycloak.hasRealmRole(module);
};

export const AuthGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);